
import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { auth_routes, routes } from "./routes";
import { resetAuthState, setAccessToken, setNewUser, setRefreshToken, setUserDetails } from "./store/auth/Auth";
import Layout from "./components/layout/Layout";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.userdetails);
  // useEffect(() => {
  //   if (!userData) {
  //     dispatch(setNewUser(null));
  //     dispatch(setUserDetails(null));
  //     dispatch(setAccessToken(""));
  //     dispatch(setRefreshToken(""));
  //     navigate("/");
  //   }
  // }, [userData, dispatch, navigate]);

  useEffect(() => {
    // Sirf tabhi navigate karein agar token nahi hai AUR user login page par nahi hai
    const path = window.location.pathname;
    if (!userData?.id && !localStorage.getItem("authToken") && path !== "/") {
      dispatch(resetAuthState());
      navigate("/");
    }
  }, [userData, navigate, dispatch]);

  return (
    <>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Routes>
        <Route path="/">
          {auth_routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>
        <Route path="/" element={<Layout />}>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default App;
